import React from 'react';

import { DxIcon } from '@atlaskit/logo/dx/icon';

import LogoTable from '../utils/logo-table';

export default (): React.JSX.Element => <LogoTable icon={<DxIcon appearance="brand" />} />;
